export const DATE_FORMATS = {
  /** "Jan 5, 2026" */
  DATE: 'MMM d, yyyy',
  /** "Jan 5, 2026, 14:30 GMT" */
  DATE_TIME_GMT: "MMM d, yyyy, HH:mm 'GMT'",
  /** "January 5, 2:30 PM" */
  LONG_DATE_TIME: 'MMMM d, h:mm a',
  /** "Jan 05, 02:30 PM" */
  SHORT_DATE_TIME: 'MMM dd, hh:mm a',
  /** "05/01/2026" */
  SLASHED_DATE: 'dd/MM/yyyy',
  /** "2026-01-05" */
  API_DATE: 'yyyy-MM-dd',
  /** "2026-01-05_14-30-00" */
  FILE_TIMESTAMP: 'yyyy-MM-dd_HH-mm-ss',
} as const;
